export default "/fonts/vendor/katex/dist/KaTeX_Size2-Regular.ttf?57f5c1837853986ea1dbadbb8f4f6074";